import axiosInstance from './axiosInstance';

const engagementService = {
  // Get all engagement lists
  getLists: async () => {
    console.log('Fetching lists from API...');
    try {
      const response = await axiosInstance.get('/api/engagement/lists');
      console.log('Lists API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getLists:', error);
      console.error('Error response:', error.response?.data);
      throw error.response?.data || error.message;
    }
  },

  // Get a specific list with its profiles
  getList: async (listId) => {
    try {
      const response = await axiosInstance.get(`/api/engagement/lists/${listId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create a new list
  createList: async (listData) => {
    try {
      const response = await axiosInstance.post('/api/engagement/lists', listData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update an existing list
  updateList: async (listId, listData) => {
    try {
      const response = await axiosInstance.put(`/api/engagement/lists/${listId}`, listData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete a list
  deleteList: async (listId) => {
    try {
      const response = await axiosInstance.delete(`/api/engagement/lists/${listId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add a profile to a list
  addProfile: async (listId, profileData) => {
    try {
      const response = await axiosInstance.post(`/api/engagement/lists/${listId}/profiles`, profileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Remove a profile from a list
  removeProfile: async (listId, profileId) => {
    try {
      const response = await axiosInstance.delete(`/api/engagement/lists/${listId}/profiles/${profileId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default engagementService; 